<div class="split-s-form">

  <!-- Header: tabs + actions -->
  <div class="split-header wg-split-header">
    <div class="wg-split-tabs">
      <button class="wg-split-tab wg-split-tab--active">
        ISKANJE
      </button>
      <button class="wg-split-tab" (click)="navigateToListing()">
        POVEZANI
      </button>
    </div>

    <div class="wg-split-actions">
      <button class="wg-split-action-btn" (click)="navigateToListing()" title="Odpri">
        <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"/></svg>
      </button>
      <button class="wg-split-action-btn wg-split-action-btn--close" (click)="close()" title="Zapri">
        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/></svg>
      </button>
    </div>
  </div>

  <!-- Search controls: IN/ALI toggle + Išči lokalno + search keyword chips -->
  <div class="split-header split-sub-header wg-split-controls">
    <sem-switch [(ngModel)]="isOr" (ngModelChange)="modelChanged($event)"></sem-switch>

    @if (!searchByCurrentModelOnly) {
      <div (click)="switchSearchMode(true)" class="wg-split-search-mode">
        <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="currentColor"/><circle cx="12" cy="12" r="5" fill="white"/></svg>
        <span>Išči povsod</span>
      </div>
    }
    @if (searchByCurrentModelOnly) {
      <div (click)="switchSearchMode(false)" class="wg-split-search-mode">
        <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/></svg>
        <span>Išči lokalno</span>
      </div>
    }

    <ng-scrollbar [visibility]="'hover'" [track]="'horizontal'">
      <div class="wg-split-chips">
        @for (item of searchService.splitSearchKeywords; track item.name) {
          <div class="wg-split-chip">
            <span class="wg-split-chip__label">{{item.name}}</span>
            <input [(ngModel)]="item.value" (ngModelChange)="searchTermChanged($event)" class="wg-split-chip__input" />
            <button class="wg-split-chip__remove" (click)="removeItem(item)">
              <svg width="10" height="10" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/></svg>
            </button>
          </div>
        }
      </div>
    </ng-scrollbar>
  </div>

  <!-- Results grid -->
  <ng-scrollbar>
    <div class="wg-split-results">
      <div class="wg-split-grid">
        @for (item of result; track item.Model.Id) {
          <a [href]="item.Model.DetailsFormUrl + '?id=' + item.Model.Id" class="wg-split-grid-item">
            <div class="wg-split-grid-item__thumb">
              <sem-image-viewer [height]="120" [width]="120"
                [mediaId]="item.Model.FirstMediaId"></sem-image-viewer>
            </div>
            <p class="wg-split-grid-item__inv">{{item.Model.InvNumber}}</p>
            <p class="wg-split-grid-item__creator">{{item.Model.DocumentCreator.Title}}</p>
            <p class="wg-split-grid-item__title">{{item.Model.Title}}</p>
          </a>
        }
      </div>
    </div>
  </ng-scrollbar>

</div>
